import _BaseAPIService from "./_BaseAPIService";

  const apiService = _BaseAPIService.instance;
const generalService = {
  getList: async () => {
    const response = await apiService.get("/pages");
    return response.data;
  },
  getbyId: async (id) => {
    const response = await apiService.get(`/pages/${id}`);
    return response.data;
  },
    getBySlug: async (slug) => {
  const params = new URLSearchParams({ slug });
  const response = await apiService.get(
    `/pages/slug?${params.toString()}`
  );
  return response.data;
},


    
}

export default generalService
